export type OperationSuccess<T> = { error: null; data: T };
export type OperationFailure<E> = { error: E; data: null };
export type OperationResult<T, E> = OperationSuccess<T> | OperationFailure<E>;

type Operation<T> = Promise<T> | (() => T) | (() => Promise<T>);

export function tryCatch<T, E = Error>(
  operation: Promise<T>
): Promise<OperationResult<T, E>>;
export function tryCatch<T, E = Error>(
  operation: () => Promise<T>
): Promise<OperationResult<T, E>>;
export function tryCatch<T, E = Error>(
  operation: () => T
): OperationResult<T, E>;
export function tryCatch<T, E = Error>(
  operation: Operation<T>
): OperationResult<T, E> | Promise<OperationResult<T, E>> {
  try {
    const result = typeof operation === 'function' ? operation() : operation;
    if (result instanceof Promise) {
      return result
        .then((data) => onSuccess(data))
        .catch((error) => onFailure(error));
    }
    return onSuccess(result);
  } catch (error) {
    return onFailure<E>(error);
  }
}

const onSuccess = <T>(value: T): OperationSuccess<T> => {
  return { error: null, data: value };
};

const onFailure = <E>(error: unknown): OperationFailure<E> => {
  return { error: error as E, data: null };
};
